import React from 'react';

const Cerez: React.FC = () => {
  return (
    <div className="pt-32 pb-24 bg-background">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-display text-white mb-8 border-b border-border/20 pb-4">Çerez Politikası</h1>
        <div className="flex flex-col gap-6 text-sm text-muted-foreground leading-relaxed">
          <p><strong>Son Güncelleme:</strong> Temmuz 2026</p>
          <p><strong>WE24 Agency</strong> olarak, sitemizi ziyaret eden kullanıcılarımızın deneyimini iyileştirmek amacıyla çerezler (cookies) kullanmaktayız. Sitemizi kullanarak çerezlerin bu politikada belirtilen şekilde kullanılmasını kabul etmiş olursunuz.</p>
          
          <h3 className="text-lg font-bold text-white mt-4">1. Çerez Nedir?</h3>
          <p>Çerezler, bir web sitesini ziyaret ettiğinizde tarayıcınız aracılığıyla cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin daha verimli çalışmasını ve tercihlerinize uygun şekilde kişiselleştirilmesini sağlar.</p>

          <h3 className="text-lg font-bold text-white mt-4">2. Hangi Çerezleri Kullanıyoruz?</h3>
          <ul className="list-disc pl-5 flex flex-col gap-2">
            <li><strong>Zorunlu Çerezler:</strong> Sitenin temel işlevlerini yerine getirmesi için zorunlu olan ve veri saklamayan çerezlerdir.</li>
            <li><strong>Performans Çerezleri:</strong> Sitenin ziyaretçi sayıları ve trafik kaynaklarını analiz etmek amacıyla kullanılan anonim istatistik çerezleridir.</li>
          </ul>

          <h3 className="text-lg font-bold text-white mt-4">3. Çerezleri Nasıl Kontrol Edebilirsiniz?</h3>
          <p>Tarayıcınızın ayarlarını değiştirerek çerezleri kabul etmeyebilir, engelleyebilir veya cihazınızdan silebilirsiniz. Çerezlerin engellenmesi durumunda web sitemizin bazı fonksiyonlarının eksiksiz çalışmayabileceğini hatırlatmak isteriz.</p>
        </div>
      </div>
    </div>
  );
};

export default Cerez;
